const URL = "https://arabianbet.net";
export default {
    URL
};
